<template>
    <div class="thumbnail">
        <!--<div class="thumbnail-detail">-->
            <div class="thumbnail-img"><img :src="this.weburl+this.parks_item.url" alt=""></div>
            <div class="thumbnail_content">
                <h4>{{this.parks_item.name}}</h4>
                <p>{{this.parks_item.intro}}</p>
                <span>{{this.parks_item.remark1}}</span>
                <span>{{this.parks_item.remark2}}</span>
                <span>{{this.parks_item.remark3}}</span>
            </div>
        <!--</div>-->
    </div>
</template>

<script>
    export default {
        props:["parks_item"],
        name: "thumbnail",
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }

        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";
    .thumbnail {
        width: 48.2%;
        .border-radius(10px);
        .box-shadow;
        margin-bottom: 20px;
        /*height: 234px;*/
        .thumbnail-img {
            width: @width;
            height: 130px;
            @media(max-width: 360px){
                height: 120px;
            }
            @media(min-width: 411px){
                height: 140px;
            }
            @media(max-width: 320px){
            height: 107px;
          }
            img{
                .img;
                .border-radius(10px 10px  0 0);
            }
        }
        .thumbnail_content {
            .box-sizing;
            width: @width;
            /*height: 84px;*/
            padding:10px  6px ;
            @media(max-width: 320px){
                height: 75px;
                padding:5px  6px ;
            }
            h4 {
                font-size:@font;
                /*height: 24px;*/
                @media(max-width: 320px){
                    font-size:@font - .05;
                    /*height: 22px;*/
                }
            }
            p {
                display: none;
            }
            span{
                line-height: 20px;
                font-size: .5rem;
                display: block;
                color:@word;
                padding-left: 10% ;
                background: url(../../assets/images/themePark/zan.png) no-repeat 0 3px;
                background-size: 12px auto;
            }

        }
    }
    @media (min-width: 768px) and (orientation: portrait){
        .thumbnail {
            width: 30.9%;
            .border-radius(10px);
            .box-shadow;
            margin-bottom: 20px;
            /*height: 234px;*/
            .thumbnail-img {
                width: @width;
                height: 175px;

                img{
                    .img;
                    .border-radius(10px 10px  0 0);
                }
            }
            .thumbnail_content {
                .box-sizing;
                width: @width;
                height: 84px;
                padding:10px  6px ;
                h4 {
                    font-size:@font + .1;
                }
                p {
                    display: none;
                }
                span{
                    font-size: .8rem;
                    background: url(../../assets/images/themePark/zan.png) no-repeat 0 0px;
                    background-size: 17px auto;
                }

            }
        }
    }
    @media (min-width: 1024px) {
        .thumbnail {
            .thumbnail-img {
                height: 235px;

            }
        }
    }


</style>
